import React from 'react'

const React_Coding_Practice_22 = () => {
  return (
    <div>
      <h1>Coding Pratice 22</h1>
    </div>
  )
}

export default React_Coding_Practice_22
